import * as React from 'react'
import { ISalesTeam, SalesTeam } from '@user/store/salesTeam'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface Props {
  salesTeam: ISalesTeam | SalesTeam | { branchName: string; name: string }
}

export function SalesTeamMenuItemLabel(props: Props) {
  const {
    salesTeam: { branchName, name },
  } = props

  return (
    <Box>
      <Typography>{name}</Typography>
      {branchName && branchName.trim().length > 0 && (
        <Typography>{branchName}</Typography>
      )}
    </Box>
  )
}
